import { useHistoryBatch } from 'contexts/HistoryBatch';
import { cpf } from 'cpf-cnpj-validator';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type PartialProcessedProps = {
  isDeactivate: boolean;
};

export const PartialProcessed = ({ isDeactivate }: PartialProcessedProps) => {
  const navigate = useNavigate();

  const { fileDetails } = useHistoryBatch();

  const { t } = useTranslation(['history', 'beneficiaries']);

  const redirectToCreateBatch = () => {
    if (isDeactivate) {
      navigate('?m=dropdown-modal-deactivate');
      return;
    }

    navigate('?m=dropdown-modal-include');
  };

  if (!fileDetails) return null;

  return (
    <>
      <div className="error-table">
        <table>
          <thead>
            <tr>
              <th>CPF</th>
              <th>Erro</th>
            </tr>
          </thead>
          <tbody>
            {fileDetails.map((item) => (
              <tr>
                <td>{cpf.format(item.cpf)}</td>
                <td>{item.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="button-container">
        <button type="button" className="reimport-button" onClick={redirectToCreateBatch}>
          {t('reimport')}
        </button>
      </div>
    </>
  );
};
